// Emoji may have the length more than one
export const getStringCharactersCount = (str: string): number => {
  return Array.from(str.normalize('NFC').trim()).length;
};
